import Banner from "../components/Banner/Banner";
import CoinTable from "../components/CoinTable";

const Homepage = () => {
  return (
    <>
      <Banner />
      <CoinTable />
    </>
  );
};

export default Homepage;